import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

import { DataTableComponent } from './components/data-table/data-table.component';
import { ContainerRodapeComponent } from './container-rodape/container-rodape.component';
import { DialogComponent } from './dialog/dialog.component';
import { DropDownComponent } from './drop-down/drop-down.component';
import { MonthDatePickerComponent } from './month-date-picker/month-date-picker.component';
import { SelecaoContaComponent } from './selecao-conta/selecao-conta.component';

import { ObservadorSharedService } from './services/observador-shared.service';

import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarModule as MatSnackBarModule,
} from '@angular/material/legacy-snack-bar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import {
  IdsActionButtonModule,
  IdsCheckboxModule,
  IdsContextualButtonComponent,
  IdsDatepickerModule,
  IdsFormFieldModule,
  IdsHighlightButtonModule,
  IdsIconButtonModule,
  IdsIconModule,
  IdsMainButtonModule,
  IdsShimmerModule,
  IdsPaginationModule,
  IdsSnackbarModule,
  IdsTabsModule,
  IdsModalModule,
  IdsTooltipModule,
  IdsLoadingModule,
  IdsAlertModule,
  IdsOverlayOriginModule,
  IdsInputSearchModule,
  IdsChipsModule,
  IdsShortcutModule,
  IdsBannerHighlightModule,
} from '@ids/angular';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DialogAlertBrowserComponent } from '../login/dialog-alert-browser/dialog-alert-browser.component';
import { AutoCompleteComponent } from './components/autocomplete/autocomplete.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { ButtonComponent } from './components/button/button.component';
import { ButtonNewComponent } from './components/button-new/button-new.component';
import { DialogConfirmComponent } from './components/dialog-confirm/dialog-confirm.component';
import { EditableDataTableComponent } from './components/editable-data-table/editable-data-table.component';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { BrlPipe } from './pipes/brl.pipe';
import { CapitalizeFirstPipe } from './pipes/capitalizefirst.pipe';
import { ContaPrefixPipe } from './pipes/contaprefix.pipe';
import { DatexPipe } from './pipes/datex.pipe';
import { DescricaoReduzidaPipe } from './pipes/descricaoReduzida.pipe';
import { MaskCnpjPipe } from './pipes/maskCnpj.pipe';
import { MaskCnpjCpfPipe} from './pipes/maskCnpjCpf.pipe';
import { MaskCpfPipe } from './pipes/maskCpf.pipe';
import { ValidaCpfService } from './services/valida-cpf.service';
import { ValidaCnpjService } from './services/valida-cnpj.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonNewComponent,
    ReactiveFormsModule,
    IdsActionButtonModule,
    IdsMainButtonModule,
    IdsCheckboxModule,
    IdsChipsModule,
    IdsContextualButtonComponent,
    IdsDatepickerModule,
    IdsHighlightButtonModule,
    IdsIconModule,
    IdsPaginationModule,
    IdsFormFieldModule,
    IdsTooltipModule,
    IdsIconButtonModule,
    IdsTabsModule,
    IdsModalModule,
    IdsLoadingModule,
    IdsInputSearchModule,
    IdsShimmerModule,
    IdsSnackbarModule,
    IdsAlertModule, 
    IdsOverlayOriginModule,
    IdsShortcutModule,
    IdsBannerHighlightModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatSnackBarModule,
  ],
  declarations: [
    CapitalizeFirstPipe,
    ContainerRodapeComponent,
    ContaPrefixPipe,
    DescricaoReduzidaPipe,
    DialogComponent,
    DropDownComponent,
    MaskCnpjPipe,
    MaskCnpjCpfPipe,
    MaskCpfPipe,
    MonthDatePickerComponent,
    SelecaoContaComponent,
    DatexPipe,
    BrlPipe,
    DataTableComponent,
    ButtonComponent,
    DialogConfirmComponent,
    DataTableComponent,
    SpinnerComponent,
    DialogAlertBrowserComponent,
    EditableDataTableComponent,
    AutoCompleteComponent,
    SnackbarComponent,
    BackButtonComponent,
    SearchInputComponent,
  ],
  providers: [
    ObservadorSharedService,
    MatSnackBar,
    provideNgxMask(),
    MaskCnpjPipe,
    MaskCnpjCpfPipe,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    ValidaCpfService,
    ValidaCnpjService
  ],
  exports: [
    ButtonNewComponent,
    CapitalizeFirstPipe,
    ContainerRodapeComponent,
    ContaPrefixPipe,
    DescricaoReduzidaPipe,
    DialogComponent,
    DropDownComponent,
    MaskCnpjPipe,
    MaskCnpjCpfPipe,
    MaskCpfPipe,
    MonthDatePickerComponent,
    SelecaoContaComponent,
    DatexPipe,
    BrlPipe,
    BackButtonComponent,
    DataTableComponent,
    FormsModule,
    ReactiveFormsModule,
    IdsActionButtonModule,
    IdsCheckboxModule,
    IdsMainButtonModule,
    IdsChipsModule,
    IdsContextualButtonComponent,
    IdsDatepickerModule,
    IdsHighlightButtonModule,
    IdsIconModule,
    IdsPaginationModule,
    IdsTooltipModule,
    IdsModalModule,
    IdsLoadingModule,
    IdsFormFieldModule,
    IdsTabsModule,
    IdsIconButtonModule,
    IdsShimmerModule,
    IdsSnackbarModule,
    IdsAlertModule,
    IdsInputSearchModule, 
    IdsOverlayOriginModule,
    IdsShortcutModule,
    IdsBannerHighlightModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    ButtonComponent,
    DialogConfirmComponent,
    SpinnerComponent,
    MatTooltipModule,
    MatMenuModule,
    DialogAlertBrowserComponent,
    MatIconModule,
    EditableDataTableComponent,
    AutoCompleteComponent,
    SnackbarComponent,
    SearchInputComponent,
  ],
})
export class SharedModule {}
